import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { getDeviceSpec } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
import { Z3KSettings, Z3KSettingsEditor } from '../../provider/types';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
export function UIGroupList() {
    const { config } = useContext(Z3KSettingsEditor);
    const { device_type, hardware_type } = useContext(Z3KSettings);
    const spec = getDeviceSpec(device_type, hardware_type);
    const childrenItem = (selected_item_id) => {
        return (_jsx(_Fragment, { children: spec.show_settings.show_UIPage &&
                spec.has_ui_groups &&
                ~~config.device?.firmware >= 100 && (_jsx(DragDropDrawer, { z3k_name: "ui_groups", name: RouteNaming[Z3kSecondRoutes.ui_groups], help_id: "ui_groups", item_url: Z3kSecondRoutes.ui_groups, enableDnd: true, selected_item_id: selected_item_id })) }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
UIGroupList.isError = () => false;
UIGroupList.isWarning = UIGroupList.isError;
UIGroupList.isShown = (is_service_view, config, spec, is_staff, is_climatic) => !is_climatic && is_service_view && spec.has_ui_groups;
